<template>
  <main>
    <tab-header />
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="radio radio-inline">
                <input type="radio" v-model="searchType" id="search-type-1" value="1">
                <label for="search-type-1">小額調撥進度</label>
              </div>
              <div class="radio radio-inline">
                <input type="radio" v-model="searchType" id="search-type-2" value="2">
                <label for="search-type-2">解鎖自招件可撥給非增員者進度</label>
              </div>
              <hr>
            </div>
          </div>
          <div v-if="searchType == '1'" :class="{'section-loading': loading_1}" >
            <div class="row">
              <div class="col-12">
                <p>單日上限：{{limitCount}}/50</p>
              </div>
            </div>
            
            <div class="row">
                <div class="col-12">
                  <section class="insurance-table newTable">
                  <div>
                    <table class="table datatable table-striped table-bordered">
                      <thead>
                        <tr>
                          <th width="60">
                            <div class="checkbox checkbox-inline mr-0">
                              <input
                              @click="activeTarget = activeTarget == `cancel-td-all`? `cancel-td-all-again`: `cancel-td-all`"
                              type="checkbox"
                              :name="`cancel-dail-all`" 
                              :id="`cancel-dail-all`"
                              v-model="checkAll">
                              <label :for="`cancel-dail-all`"></label>
                            </div>
                          </th>
                          <th class="sorting"
                            :class="(order.index==5 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                            @click="columnSorting(5)">要保人</th>
                          <th class="sorting"
                            :class="(order.index==3 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                            @click="columnSorting(3)">保單號碼</th>
                          <th class="sorting"
                            :class="(order.index==1 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                            @click="columnSorting(1)">原收費代號/收費人員</th>
                          <th class="sorting"
                            :class="(order.index==2 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                            @click="columnSorting(2)">新收費代號/收費人員</th>
                          <th>調撥進度</th>
                          <th class="sorting"
                            :class="(order.index==4 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                            @click="columnSorting(4)">申請日期</th>
                        </tr>
                      </thead>
                      <tbody v-if="tableData.length">
                        <tr v-for="(item, index) in tableData" :key="`cancel-${index}`"
                          :class="{'disable-gray': item.type == '3'}">
                          <td>
                            <div class="mr-0 checkbox checkbox-inline" v-if="item.type == '1'">
                              <input
                              @click="activeTarget = activeTarget == `cancel-td-${index}`? `cancel-td-${index}-again`: `cancel-td-${index}`"
                              type="checkbox"
                              :name="`cancel-dail-td-item`"
                              :id="`cancel-dail-${index}`"
                              v-model="tableSelection"
                              :value="item">
                              <label :for="`cancel-dail-${index}`"></label>
                            </div>
                          </td>
                         <td>{{ item.ceapcnm }}</td>
                          <td>{{ item.plcno }}</td>
                          <td>{{ item.ceclcno_old }}/{{ item.ceclcnm_old }}</td>
                          <td>{{ item.ceclcno_new }}/{{ item.ceclcnm_new}}</td>
                          <td>{{ item.status }}</td>
                          <td>{{ item.e5 | dateFormat }}</td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td :colspan="6" class="empty-block bg-white">
                            <h3 class="bg-white">無任何資料</h3>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>
                </div>
                <div class="col-12">
                  <a class="btn btn-primary float-right" disabled v-if="!tableSelection.length">取消調撥</a>
                  <a class="btn btn-primary float-right" @click="confirmCheck()" v-else>取消調撥</a>
                  <p>
                    註1. 資料更新之系統處理時間為3-5個工作天<br/>
                    註2. 取消調撥期限為每日PM 7:30
                  </p>
                </div>
            </div>
          </div>

          <div v-if="searchType == '2'" :class="{'section-loading': isResignUnlockLoading}" >
            <table class="table datatable insurance-green table-striped table-bordered">
              <thead>
                <tr>
                  <th>輸入日期</th>
                  <th>覆核日期</th>
                  <th>離職收費代號</th>
                  <th>離職者姓名</th>
                  <th>增員者</th>
                  <th>輸入原因</th>
                  <th>輸入人員</th>
                  <th>覆核人員</th>
                  <th>進度</th>
                </tr>
              </thead>
              <tbody v-if="resignUnlockRecord.length">
                <tr v-for="(item, rid) in resignUnlockRecord" :key="`row-${rid}`">
                  <td width="110"> {{ item.c_upd_time ? item.c_upd_time.substring(0, item.c_upd_time.indexOf(" ")) : "" }} </td>
                  <td width="110"> {{ item.mgr_upd_time ? item.mgr_upd_time.substring(0, item.mgr_upd_time.indexOf(" ")) : "" }} </td>
                  <td width="110"> {{ item.resign_ceclcno }} </td>
                  <td width="100"> {{ item.resign_name }} </td>
                  <td width="100"> {{ item.intr_name }} </td>
                  <td width="200"> {{ item.memo }} </td>
                  <td width="100"> {{ item.c_name }} </td>
                  <td width="100"> {{ item.mgr_name }} </td>
                  <td width="100"> {{ item.mgr_upd_time ? "處理完成" : "處理中" }} </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td :colspan="9" class="empty-block bg-white">
                    <h3 class="bg-white">查無資料</h3>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    
    <warning-modal
    :open="cancelCheckOpen"
    :message="'你是否確認要取消調撥？'"
    @submit="cancelCheck"
    @close="panelClose('cancelCheckOpen')"
    />
  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import TabHeader from '@/desktop/components/manager/TabHeader'
import WarningModal from '@/desktop/components/WarningModal'
import { debuglog } from 'util';
import { allocationStatusProcess, doQueryResignList } from '../../../service'

export default {
  name: 'TransferTab2',
  mixins: [commonMixin],
  components: {
    TabHeader,  WarningModal
  },
  computed: {
  },
  data () {
    return {
      order: {
        index: 1,
        asc: true
      },
      loading_1: false,
      cancelCheckOpen: false,
      tableData: [],
      tableType1DataNo: {},
      tableSelection: [],
      checkAll: false,
      activeTarget: '',
      limitCount: '?',
      searchType: "1",
      isResignUnlockLoading: false,
      resignUnlockRecord: []
    }
  },
  watch: {
    'activeTarget': 'checkSelectedData',
    /**
     * 查詢相對應的資料
     * @param {*} val 
     */
     searchType: function(val) {
      // 2: 解鎖自招件可撥給非增員者
      if (val === "2") {
        this.initResignUnlockRecord();
      }
    }
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    columnSorting(i) {
      //切換表頭圖案
      if (this.order.index == i) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.asc = true;
      }
      this.order.index = i;

      //data排序
      switch (i) {
        case 1:
          this.tableData.sort(this.sortCompareFun("ceclcno_old", "ceclcnm_old"))
          break;
        case 2:
          this.tableData.sort(this.sortCompareFun("ceclcno_new", "ceclcnm_new"))
          break;
        case 3:
          this.tableData.sort(this.sortCompareFun("plcno"))
          break;
        case 4:
          this.tableData.sort(this.sortCompareFun("e5"))
          break;
        case 5:
          this.tableData.sort(this.sortCompareFun("ceapcnm"))
        break;
        default:
          break;
      }

      // for 難字 update
      let cacheList = [...this.tableData]
      this.tableData = []
      setTimeout(() => {
        this.tableData = cacheList
        this.registerHanlink()
      }, 200)
      
    },
    sortCompareFun(mainProperty, subProperty = null) {
      let sortOrder = 1;
      if (!this.order.asc) {
        sortOrder = -1;
      }
      return function(a, b) {
        let result =
          a[mainProperty] < b[mainProperty] ? -1 : a[mainProperty] > b[mainProperty] ? 1 : 0;
        if (result == 0 && subProperty != null) {
          result = a[subProperty] < b[subProperty] ? -1 : a[subProperty] > b[subProperty] ? 1 : 0;
        }
        return result * sortOrder;
      };
    },
    checkSelectedData() {
      if(this.activeTarget == 'cancel-td-all-again' || this.activeTarget == 'cancel-td-all') {  //點了全選checkbox
        if(this.checkAll) {  //點了全選
          this.tableSelection = []
          this.tableData.forEach(data => {
            if(Object.keys(this.tableType1DataNo).includes(data.plcno)) {
              this.tableSelection.push(data)
            }
          });
        } else {  //取消全選
          this.tableSelection = []
        }
      } else {  //點了其他checkbox
        this.checkAll = Object.keys(this.tableType1DataNo).length == this.tableSelection.length
      }
    },
    confirmCheck () {
      this.panelOpen('cancelCheckOpen')
    },
    //==================== API功能 ====================
    cancelCheck () {
      let plcnoAry = this.tableSelection.map(ele => {return ele.plcno})
      this.panelClose('cancelCheckOpen')
      this.loading_1 = true
      allocationStatusProcess(this.$store.state.userInfo.id, this.$store.state.userInfo.id, '3', plcnoAry).then(result => {
        if(result.header && result.header.status == '200') {
          this.tableSelection = []
          this.changeRawDataTypeToAlreadyCancel(plcnoAry)
          this.getCheckNsaLimit()
          this.$toast.info({title: '已取消調撥！'})
        } else {
          if(result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '取消失敗,請重新操作'})
          }
        }
        this.loading_1 = false
      })
    },
    changeRawDataTypeToAlreadyCancel(plcnoAry) {
      this.tableData = this.tableData.map(ele => {
        if(plcnoAry.includes(ele.plcno)) {
          ele.type = '3'
          ele.status = '已取消調撥'
          delete this.tableType1DataNo[ele.plcno];
        }
        return ele
      })
    },
    classifyData(allocationStatusData) {
      switch(allocationStatusData.status) {
        case "待覆核":
          allocationStatusData['type'] = '1'
          this.tableType1DataNo[allocationStatusData.plcno] = allocationStatusData.plcno
          break;
        case "已覆核":
          allocationStatusData['type'] = '2'
          break;
        case "已取消調撥":
          allocationStatusData['type'] = '3'
          break;
        default:
          allocationStatusData['type'] = '2'
          break;
      }
      return allocationStatusData
    },
    getCheckNsaLimit() {
      this.limitCount = '?'
      allocationStatusProcess(this.$store.state.userInfo.id, this.$store.state.userInfo.id, '2', null).then(result => {
        if(result.header && result.header.status == '200') {
          this.limitCount = result.body.check_nsa_limit.count
        } else {
          if(result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '當日上限數目查詢失敗,請重新操作'})
          }
        }
      })
    },
    getAllocationStatusList() {
      this.tableData = []
      this.tableType1DataNo = {}
      this.loading_1 = true
      allocationStatusProcess(this.$store.state.userInfo.id, this.$store.state.userInfo.id, '1', null).then(result => {
        if(result.header && result.header.status == '200') {
          this.tableData = result.body.allocation_status.map(data => {return this.classifyData(data)})
        } else {
          if(result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '進度清單查詢失敗,請重新操作'})
          }
        }
        this.loading_1 = false
        this.registerHanlink()
      })
    },
    initTransferTab2() {
      this.getCheckNsaLimit()
      this.getAllocationStatusList()
    },
    // 初始解鎖自招件可撥給非增員者
    initResignUnlockRecord() {
      this.isResignUnlockLoading = true;
      const cedvno3 = this.$store.state.userInfo.divNo.substring(0, 3);
      doQueryResignList(this.$store.state.userInfo.id, cedvno3, "IS_SUBMANGER", this.$store.state.userInfo.id).then(result => {
        this.isResignUnlockLoading = false;
        if (result && result.header.status == "200" && result.body) {
          this.resignUnlockRecord = result.body.rtn_list || [];
        }
      });
    }
  },
  beforeMount () {
    this.initTransferTab2()
  },
  mounted () {
  }
}
</script>
